import React, { useContext, useState } from 'react'
import { NotificationContext } from '../../context/NotificationContext'
import { AuthContext } from '../Auth/AuthProvider'
import { Role, useUpdateUserRoleMutation } from 'src/gql/graphql'
import { useTranslation } from 'react-i18next'

export const ReserveTokenWrapper = ({
  children,
  style,
}: {
  children: React.ReactNode
  style?: React.CSSProperties
}) => {
  const { userInfo } = useContext(AuthContext)
  const { t } = useTranslation()
  const { isTokenAvailable } = useContext(NotificationContext)
  const [closed, setClosed] = useState(false)

  const currentRole = userInfo?.employeeDetails?.role?.name
  const doesInlucdeITRole = userInfo?.roles?.some(
    (role) => role?.name === Role.It,
  )
  const [switchProfile] = useUpdateUserRoleMutation()
  const isAdmin = currentRole === Role.It || !!doesInlucdeITRole

  const handleOnClick = async () => {
    if (currentRole === Role.It) {
      window.open('/it-dashboard/plan-selection', '_self')
      return
    }
    const employeeId = userInfo?.employeeDetails?.employeeId
    const roleItId = userInfo?.roles?.find((role) => role?.name === Role.It)?.id
    if (!roleItId || !employeeId) return

    await switchProfile({
      variables: {
        employeeId,
        roleId: roleItId,
      },
      onCompleted: () => {
        window.open('/it-dashboard/plan-selection', '_self')
      },
    })
  }

  if (!isTokenAvailable && !closed) {
    return (
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        <div
          style={{
            filter: 'blur(3px)',
            pointerEvents: 'none',
            userSelect: 'none',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          {children}
        </div>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.4)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
            ...style,
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 8,
              padding: '24px 16px',
              boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
              minWidth: 220,
              maxWidth: 360,
              width: '100%',
              textAlign: 'center',
              wordBreak: 'break-word',
              position: 'relative',
            }}
          >
            <button
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'transparent',
                border: 'none',
                fontSize: 18,
                cursor: 'pointer',
                color: '#888',
              }}
              onClick={() => setClosed(true)}
            >
              ×
            </button>
            <div style={{ marginBottom: 16, fontWeight: 500, fontSize: 16 }}>
              {t(
                'resource.usage.outOfToken',
                'Our apologies, it seems you have run out of tokens on your current plan.',
              )}
            </div>
            <div
              style={{
                color: 'var(--color-primary)',
                fontWeight: 600,
                cursor: isAdmin ? 'pointer' : 'default',
                display: 'inline-block',
                wordBreak: 'break-word',
              }}
              onClick={handleOnClick}
            >
              {isAdmin
                ? 'Please upgrade your plan or purchase more'
                : 'Please contact your admin to enable more'}
            </div>
          </div>
        </div>
      </div>
    )
  }
  return <>{children}</>
}
